import React from 'react';
import ProfilePage from '../../profile/ProfilePage';

export const MemberDetail = ( props ) => {
    const { location } = props;
    return <ProfilePage memberId={ location.query.id }  guestMode/>
}


// WEBPACK FOOTER //
// src/client/components/site/features/members/pages/MemberDetail.js